export namespace Coordinates {
  export namespace Plugin {
    export const Name = 'coordinates';
  }
}
